// react
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// application
import FooterContacts from './FooterContacts';
import FooterLinks from './FooterLinks';
import FooterNewsletter from './FooterNewsletter';
import ToTop from './ToTop';

// data stubs
import theme from '../../data/theme';

export default function Footer() {

    const userConnected = useSelector((state) => state.user.userConnected.user);

    const informationLinks = [
        { title: <FormattedMessage id="footer.aboutUs" defaultMessage="About Us" />, url: '/site/about-us' },
        { title: <FormattedMessage id="footer.termsAndConditions" defaultMessage="Terms And Conditions" />, url: '/site/terms' },
        // { title: <FormattedMessage id="footer.brands" defaultMessage="Brands" />, url: '' },
        { title: <FormattedMessage id="footer.returns" defaultMessage="Returns" />, url: '/site/contact-us' },
    ];

    const accountLinks = [
        { title: <FormattedMessage id="Account.orderHistory" defaultMessage="Order History" />, url: '/account/orders' },
        { title: <FormattedMessage id="Account.profile" defaultMessage="Profile" />, url: '/account/profile' },
        { title: <FormattedMessage id="Account.password" defaultMessage="Password" />, url: '/account/password' },
    ];

    const createAccountLinks = [
        { title: <FormattedMessage id="Account.createAccount" defaultMessage="Create An Account" />, url: '/account/login' },
    ];

    return (
        <div className="site-footer">
            <div className="container">
                <div className="site-footer__widgets">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-4">
                            <FooterContacts />
                        </div>
                        <div className="col-6 col-md-3 col-lg-3">
                            <FooterLinks
                                title={<FormattedMessage id="footer.information" defaultMessage="Information" />}
                                items={informationLinks}
                            />
                        </div>
                        <div className="col-6 col-md-3 col-lg-3">
                            {userConnected ? <FooterLinks
                                title={<FormattedMessage id="footer.myAccount" defaultMessage="My Account" />}
                                items={accountLinks}
                            /> : <FooterLinks
                                title={<FormattedMessage id="footer.myAccount" defaultMessage="My Account" />}
                                items={createAccountLinks}
                            />}
                        </div>
                        <div className="col-12 col-md-12 col-lg-2 ">
                            <FooterNewsletter />
                        </div>
                    </div>
                </div>

                <div className="site-footer__bottom">
                    <div className="site-footer__copyright">
                        <FormattedMessage id="footer.poweredBy" defaultMessage="Powered by Noumï Distribution" />
                    </div>
                </div>
            </div>
            <ToTop />
        </div>
    );
}
